module.exports = __webpack_public_path__ + "img/PackCat.f94f6dab.svg";